var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckBoxOutlineBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1368_14505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1368_14505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4003 44.1667C11.3839 44.1667 10.5353 43.8263 9.85436 43.1454C9.17346 42.4645 8.83301 41.6158 8.83301 40.5994V12.4007C8.83301 11.3843 9.17346 10.5356 9.85436 9.85473C10.5353 9.17383 11.3839 8.83337 12.4003 8.83337H40.5991C41.6154 8.83337 42.4641 9.17383 43.145 9.85473C43.8259 10.5356 44.1663 11.3843 44.1663 12.4007V40.5994C44.1663 41.6158 43.8259 42.4645 43.145 43.1454C42.4641 43.8263 41.6154 44.1667 40.5991 44.1667H12.4003ZM12.4003 41.9584H40.5991C40.9388 41.9584 41.2502 41.8168 41.5333 41.5337C41.8165 41.2506 41.958 40.9391 41.958 40.5994V12.4007C41.958 12.0609 41.8165 11.7495 41.5333 11.4664C41.2502 11.1833 40.9388 11.0417 40.5991 11.0417H12.4003C12.0606 11.0417 11.7491 11.1833 11.466 11.4664C11.1829 11.7495 11.0413 12.0609 11.0413 12.4007V40.5994C11.0413 40.9391 11.1829 41.2506 11.466 41.5337C11.7491 41.8168 12.0606 41.9584 12.4003 41.9584Z",
    fill: "#01CC9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOutlineBlank);
export default __webpack_public_path__ + "static/media/check_box_outline_blank.a33739ad498e559f6f0a8ba568e5ce8e.svg";
export { ForwardRef as ReactComponent };